import React from 'react';
import { IltLearnerAssistantPanel } from './IltLearnerAssistantPanel';

interface IltLearnerAssistantLayoutProps {
    children?: React.ReactNode;
}

/**
 * Wraps page content and mounts the ILT Learner Assistant chatbot built on the
 * shared `ChatbotV2` component. The chatbot renders in floating mode, providing
 * its own launcher button and draggable/resizable window, so no custom panel
 * chrome or layout splitting is needed — we render the content and the floating
 * panel alongside it.
 *
 * This is the replacement for the legacy `AIChatbotLayout` (WebSocket + remote
 * MFE). Mounted behind the `MYCLASS_AI_CHATBOT` flag at the page level.
 */
export const IltLearnerAssistantLayout = ({ children }: IltLearnerAssistantLayoutProps) => {
    return (
        <>
            {children}
            <IltLearnerAssistantPanel />
        </>
    );
};
